/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number,
    bool, arrayOf, func, object,
} from 'prop-types';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Tooltip } from '@material-ui/core';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';

const { PERSIST_KEY } = configENV;

class ShopTheSite extends React.Component {
    handleShopTheSiteButtonClicked = (recipient) => {
        const {
            remainingRecipient,
            location: { pathname: giftListURL },
            noShopTheSiteConfirmation,
            handleConfirmGiftListShopTheSiteClicked,
            handleGiftListShopTheSiteClicked,
        } = this.props;

        const recipientWithCounter = { ...recipient, remainingRecipient, giftListURL };

        if (
            noShopTheSiteConfirmation && recipient.firstname && recipient.lastname
            && recipient.address && recipient.address.street && recipient.address.city
            && recipient.address.zipcode && recipient.address.country?.id
            && recipient.address.state?.name && recipient.address.location?.name
        ) {
            handleConfirmGiftListShopTheSiteClicked(
                recipientWithCounter,
                '/',
                true,
            );
        } else {
            handleGiftListShopTheSiteClicked(recipientWithCounter);
        }
    };

 renderEnterNumber= () => (
     <span className="enter-item-number"> Enter item #
         <Tooltip className="enter-item-tooltip" title="For best results, enter item numbers without the prefix Ex.4151X.">
             <InfoOutlinedIcon />
         </Tooltip>
     </span>
 )

 render() {
     const { customClass, track } = this.props;
     const {
         recipient,
         handleGiftListEnterItemNumberClicked, GiftListV2,
     } = this.props;

     if (!isEmpty(recipient.cartDetail)) return null;

     const recipientNoError = recipient;
     recipientNoError.error = {};
     return (
         <>
             <div
                 className={customClass}
             >
                 <div className="findAnotherGift">Find another gift for {recipient.firstname} {recipient.lastname}:</div>
                 <div className="shopTheSiteWrapper">
                     <span
                         role="presentation"
                         className="enter-item-number-button"
                         onClick={() => {
                             track({
                                 eventCategory: 'GiftList',
                                 eventAction: 'Enter Item Number',
                                 eventLabel: '',

                                 ga_event_name: 'gift_list_interaction',
                                 interaction_type: 'add_item',
                             });
                             handleGiftListEnterItemNumberClicked(recipientNoError);
                         }}
                     >
                         {GiftListV2 ? this.renderEnterNumber() :  'Enter item number'}
                     </span>
                     <span
                         role="presentation"
                         className="shop-the-site-button"
                         onClick={() => {
                             track({
                                 eventCategory: 'GiftList',
                                 eventAction: 'Shop The Site',
                                 eventLabel: '',
                             });
                             this.handleShopTheSiteButtonClicked(recipientNoError);
                         }}
                     >
                         Shop the site
                     </span>
                     <div className="tooltipWrapper">
                         <div className="tooltipIcon" />
                         <div className="tooltipContent">
                             By using SHOP THE SITE, we will autofill your recipient&apos;s information on the checkout page.
                         </div>
                     </div>
                 </div>
             </div>
         </>
     );
 }
}

ShopTheSite.defaultProps = {
    customClass: '',
    location: {},
    recipient: {},
    noShopTheSiteConfirmation: false,
    GiftListV2: false,
};

ShopTheSite.propTypes = {
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: string,
                discountPrice: string,
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    customClass: string,
    location: object,
    remainingRecipient: number.isRequired,
    noShopTheSiteConfirmation: bool,
    handleGiftListShopTheSiteClicked: func.isRequired,
    handleConfirmGiftListShopTheSiteClicked: func.isRequired,
    handleGiftListEnterItemNumberClicked: func.isRequired,
    track: func.isRequired,
    GiftListV2: bool,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('ShopTheSite - newState', newState);
    return {
        toggleState: newState.toggleState,
        remainingRecipient: newState.giftList.remainingRecipient,
        noShopTheSiteConfirmation: newState.giftList.noShopTheSiteConfirmation,
        contactId: newState.userProfile.ContactId,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListShopTheSiteClicked: (recipient) => dispatch(EventDispatcher.handleGiftListShopTheSiteClicked(recipient, 'desktop')),
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
    )),
    handleGiftListEnterItemNumberClicked: (recipient) => dispatch(EventDispatcher.handleGiftListEnterItemNumberClicked(recipient, 'desktop')),
    handleWrapperModal: (data) => dispatch(EventDispatcher.handleOpenModal(data)),
    track: bindActionCreators(trackEvent, dispatch),
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ShopTheSite));
